import { render, staticRenderFns } from "./slider-value.mpx?vue&type=template&id=6de28ac1&isComponent&outputPath=components%2Fslider-valuefa262744%2Findex"
import script from "./slider-value.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-valuefa262744%2Findex"
export * from "./slider-value.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-valuefa262744%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports